import React from "react";
import UserGroupsTable from "./UserGroupsTable";

interface ContainerProps {
    setEditOpen: any;
    setDeleteOpen: any;
    setUserGroupToModify: any;
}

// No filters on this page: the table takes the whole width
const UserGroupsContainer: React.FC<ContainerProps> = ({setEditOpen, setDeleteOpen, setUserGroupToModify}) => (
  <div className="lp-layout filters-hidden">
    <UserGroupsTable
      setEditOpen={setEditOpen}
      setDeleteOpen={setDeleteOpen}
      setUserGroupToModify={setUserGroupToModify}
    />
  </div>
);

export default UserGroupsContainer;
